import { createContext } from 'react';
import { Video } from '../types/Video';

/** How the viewer should be opened. */
export interface VideoViewerModalOptions {
  /**
   * Second to start playback at. Used when the caller knows where in the video
   * the answer is — the companion's `show_video` serve tool carries one.
   * Omitted plays from the start, which is what every other caller wants.
   */
  startSecond?: number;
  /**
   * The study set the video was served in (ORA-677). Rides on the player's
   * progress and completion writes so watching it marks the set's item done.
   */
  studySetId?: string;
}

export interface VideoViewerModalContextValue {
  open: (video: Video, options?: VideoViewerModalOptions) => void;
  close: () => void;
}

export const VideoViewerModalContext = createContext<
  VideoViewerModalContextValue | undefined
>(undefined);
